/**
 * Nav model for the product-admin console shell (WSRPDM-0011).
 *
 * Two ordered groups (Operations / Configuration) feed AppLayout's sidebar.
 * `badge` names a future live-count slot (queue/notifications/tenants) that
 * WSRPDM-0012–0017 wire up from real data — this spec renders no badges at
 * all, so the field is inert here on purpose.
 */
import type { ReactNode } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ListAltIcon from '@mui/icons-material/ListAlt';
import NotificationsIcon from '@mui/icons-material/Notifications';
import BusinessIcon from '@mui/icons-material/Business';
import SettingsIcon from '@mui/icons-material/Settings';
import TuneIcon from '@mui/icons-material/Tune';

export type NavBadgeKey = 'queue' | 'notifications' | 'tenants';

export interface NavItem {
  to: string;
  key: string;
  fallback: string;
  icon: ReactNode;
  badge?: NavBadgeKey;
}

export interface NavGroup {
  groupKey: string;
  groupFallback: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    groupKey: 'nav.group.operations',
    groupFallback: 'Operations',
    items: [
      { to: '/dashboard', key: 'nav.dashboard', fallback: 'Dashboard', icon: <DashboardIcon /> },
      {
        to: '/queue',
        key: 'nav.queue',
        fallback: 'Queue',
        icon: <ListAltIcon />,
        badge: 'queue',
      },
      {
        to: '/notifications',
        key: 'nav.notifications',
        fallback: 'Notifications',
        icon: <NotificationsIcon />,
        badge: 'notifications',
      },
    ],
  },
  {
    groupKey: 'nav.group.configuration',
    groupFallback: 'Configuration',
    items: [
      {
        to: '/tenants',
        key: 'nav.tenants',
        fallback: 'Tenants',
        icon: <BusinessIcon />,
        badge: 'tenants',
      },
      { to: '/engine', key: 'nav.engine', fallback: 'Engine', icon: <SettingsIcon /> },
      {
        to: '/global-config',
        key: 'nav.globalConfig',
        fallback: 'Global config',
        icon: <TuneIcon />,
      },
    ],
  },
];
